import { render, staticRenderFns } from "./RemoveBackgroundModal.vue?vue&type=template&id=98c78990&scoped=true"
import script from "./RemoveBackgroundModal.vue?vue&type=script&lang=js"
export * from "./RemoveBackgroundModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c78990",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98c78990')) {
      api.createRecord('98c78990', component.options)
    } else {
      api.reload('98c78990', component.options)
    }
    module.hot.accept("./RemoveBackgroundModal.vue?vue&type=template&id=98c78990&scoped=true", function () {
      api.rerender('98c78990', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/RemoveBackgroundModal.vue"
export default component.exports